export default {
  mode: "live", // liveかdateか

  selectedChannelOriginId: 'custom',  //  -> 数値または文字列
  selectedChannelGroupIdMap: {},
  // selectedCategory: "custom", // 汎用カテゴリー
  engineInfo: {},
  channelOriginsMap: {},
  channelGroupsMapByOrigin: {},

  liveDataTimeRange: 60, // minutes

  // チャンネルデータ検索条件
  channelTimeFrom: null, //"2020-10-12T01:55:00.000Z",
  channelTimeTo: null,
  // categoryId: null,
  // categoryNum: null,
  // categoryLayer: "2", // 常にcategory2を検索
  customChannelIds: [], // カスタムレポートの検索IDリスト
  unsubscribes: [],
  unsubscribesForChart: [],
  latestChannelData: {}, // FireStoreに入ってくる最新チャンネルデータの連携用.

  liveModeStartFrom: null, //"2020-10-12T01:55:00.000Z",

  channelMaster: {},
  // alertSummaryLiveDatas: [],
  // eventSummaryLiveDatas: [],
  prevFirestoreDocument: {},
  referencedChannelIdMap: {}, // 画面参照されたchannelIdをMap型で保持
  
  // X軸マウスフォーカスポイント
  channelGroupFocusPointMap: {
    // channelGroup: time
  },

  vesselMonitoringEngineStart: 0,  // 描画速度検証用。
}